import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from 'react-toastify';
import { GET_ADDDRIVER_FAILED, GET_ADDDRIVER_REQUESTED, GET_ADDDRIVER_SUCCESS, GET_UPDATEDRIVER_FAILED, GET_UPDATEDRIVER_REQUESTED, GET_UPDATEDRIVER_SUCCESS, GET_DRIVER_FAILED, GET_DRIVER_REQUESTED, GET_DRIVER_SUCCESS, GET_MATRIXDRIVER_SUCCESS, GET_MATRIXDRIVER_FAILED, GET_MATRIXDRIVER_REQUESTED, GET_TICKETDRIVER_SUCCESS, GET_TICKETDRIVER_FAILED, GET_TICKETDRIVER_REQUESTED, GET_MOREDRIVER_SUCCESS, GET_MOREDRIVER_FAILED, GET_MOREDRIVER_REQUESTED } from "resources/actionTypes";
import { addDriverApi, updateDriverApi, driverApi, moreDriverApi, ticketDriverApi, matrixDriverApi } from "services/DriverService";
import store from "redux/store";
import { getDriver } from "redux/actions/UserDriver";
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchDriver(action) {
  try {
    const payload = action.payload || {}
    const userDriver = yield call(driverApi, payload);
    yield put({
      type: GET_DRIVER_SUCCESS,
      userDriver: userDriver
    });
  } catch (e) {
    yield put({
      type: GET_DRIVER_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Driver Failed')
  }
}

export function* driverSaga() {
  yield takeEvery(GET_DRIVER_REQUESTED,
    fetchDriver);
}

function* fetchAddDriver(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddDriver = yield call(addDriverApi, payload.userAddDriver);
  if (userAddDriver.success) {
    yield put({ type: GET_ADDDRIVER_SUCCESS, userAddDriver: userAddDriver });
    toast.success(userAddDriver.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getDriver({ id: payload?.userAddDriver?.parentId, status:'', page:"", pageSize:"", date:"" }))
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_ADDDRIVER_FAILED, message: userAddDriver.message });
      toast.error(userAddDriver.message || 'Add Driver failed');
  }
}

export function* addDriverSaga() {
  yield takeEvery(GET_ADDDRIVER_REQUESTED, fetchAddDriver);
}

function* fetchUpdateDriver(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateDriver = yield call
    (updateDriverApi, payload.userUpdateDriver);
  if (userUpdateDriver.success) {
    yield put({ type: GET_UPDATEDRIVER_SUCCESS, userUpdateDriver: userUpdateDriver });
    toast.success(userUpdateDriver.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userUpdateDriver?.parentId){
      store.dispatch(getDriver({ id: payload?.userUpdateDriver?.parentId, status:'', page:"", pageSize:"", date:"" }))
    }else{
    store.dispatch(getDriver({ driverId: payload.userUpdateDriver.driverId }))
    }
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_UPDATEDRIVER_FAILED, message:
        userUpdateDriver.message
    });
      toast.error(userUpdateDriver.message || 'Update Driver failed');
  }
}

export function* updateDriverSaga() {
  yield takeEvery(GET_UPDATEDRIVER_REQUESTED, fetchUpdateDriver);
}

function* fetchMatrixDriver(action) {
  try {
    const payload = action.payload || {}
    const userMatrixDriver = yield call(matrixDriverApi, payload);
    yield put({
      type: GET_MATRIXDRIVER_SUCCESS,
      userMatrixDriver: userMatrixDriver
    });
  } catch (e) {
    yield put({
      type: GET_MATRIXDRIVER_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Matrix Driver Failed')
  }
}

export function* matrixDriverSaga() {
  yield takeEvery(GET_MATRIXDRIVER_REQUESTED,
    fetchMatrixDriver);
}

function* fetchTicketDriver(action) {
  try {
    const payload = action.payload || {}
    const userTicketDriver = yield call(ticketDriverApi, payload);
    yield put({
      type: GET_TICKETDRIVER_SUCCESS,
      userTicketDriver: userTicketDriver
    });
  } catch (e) {
    yield put({
      type: GET_TICKETDRIVER_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Ticket Driver Failed')
  }
}

export function* ticketDriverSaga() {
  yield takeEvery(GET_TICKETDRIVER_REQUESTED,
    fetchTicketDriver);
}

function* fetchMoreDriver(action) {
  try {
    const payload = action.payload || {}
    const userMoreDriver = yield call(moreDriverApi, payload);
    yield put({
      type: GET_MOREDRIVER_SUCCESS,
      userMoreDriver: userMoreDriver
    });
  } catch (e) {
    yield put({
      type: GET_MOREDRIVER_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get More Driver Failed')
  }
}

export function* moreDriverSaga() {
  yield takeEvery(GET_MOREDRIVER_REQUESTED,
    fetchMoreDriver);
}